import { useEffect, useState } from 'react';
import { BasicTable } from 'components/BasicTable/BasicTable';
import { useNavigate } from 'react-router-dom';
import PrimaryBtn from 'components/btns/PrimaryBtn';
import useApiHook from 'hooks/useApiHook';
import { toast } from 'react-toastify';
// import Spiner from "helper/Spiner";
// import { ADS_COLUMNS } from "helper/data";
import DeleteModal from 'modals/common/DeleteModal';
import { useDispatch, useSelector } from 'react-redux';
import { toggleIsDeleteModalOpen } from 'redux/dashbbaord/dashboardSlice';
import { LargeMicrophoneSvg } from 'helper/helper';
import SwitchBtn from 'components/switchBtn/SwitchBtn';
import CampaignActionBtns from 'components/Campaign/CampainActionBtns';
import Spiner from 'helper/Spiner';

const AdsManagment = () => {
  const { auth, dashboard } = useSelector((state) => state);
  const [deleteModalOpen, setDeleteModalOpen] = useState(
    dashboard?.isDeleteModalOpen
  );
  const [selectedAd, setSelectedAd] = useState(auth?.selectedAd);
  const [searchValue, setSearchValue] = useState('');
  const { handleApiCall, isApiLoading } = useApiHook();
  const [count, setCount] = useState();
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const [ads, setAds] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const ADS_COLUMNS = [
    {
      Header: 'Campaign',
      accessor: 'title',
      Cell: ({ row }) => {
        return (
          <button
            className='flex flex-row items-center whitespace-nowrap'
            onClick={() => navigate(`/ads-management/${row?.original?._id}`)}
          >
            <img
              src={row?.original?.logos[0]?.src}
              alt='Profile Avatar'
              className='mr-2 h-8 w-8 relative rounded-full object-cover'
            />
            <p className='hover:text-black'>{row?.original?.title}</p>
          </button>
        );
      },
    },
    {
      Header: 'Company',
      accessor: 'company',
    },
    {
      Header: 'Ad',
      accessor: 'heading',
    },
    {
      Header: 'Start',
      accessor: 'startDateAndTime',
      Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : ''),
    },
    {
      Header: 'End',
      accessor: 'endDateAndTime',
      Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : ''),
    },
    {
      Header: 'Status',
      accessor: 'active',
      Cell: ({ row }) => (
        <SwitchBtn
          isApiLoading={isApiLoading}
          currentState={row?.original?.active}
          value={row?.original}
          handleChange={changeStatus}
        />
      ),
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <CampaignActionBtns
          adData={row?.original}
          navigate={navigate}
          setSelectedAd={setSelectedAd}
          handleDeleteModal={handleDeleteModal}
        />
      ),
    },
  ];

  const handleDeleteModal = () => {
    setDeleteModalOpen(true);
    dispatch(toggleIsDeleteModalOpen(true));
  };

  const changeStatus = async (ad) => {
    const result = await handleApiCall({
      method: 'post',
      url: `admin/ads/toggle-status/${ad?._id}`,
    });
    if (result?.status === 200) {
      getAllAds();
      toast.success(result?.data?.message);
    }
  };

  const handleAddNewAd = () => {
    navigate('/ads-management/new-campaign');
  };

  const getAllAds = async () => {
    const result = await handleApiCall({
      method: 'get',
      url: `/admin/ads/all?page=${page}&pageSize=${pageCount}`,
    });
    if (result?.status === 200) {
      setAds(result?.data?.ads);
      setCount(result?.data?.count);
    }
  };

  const deleteAd = async () => {
    const result = await handleApiCall({
      method: 'delete',
      url: `admin/ads/delete/${selectedAd?._id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (result?.status === 200) {
      setDeleteModalOpen(false);
      dispatch(toggleIsDeleteModalOpen(false));
      getAllAds();
      toast.success(result?.data?.message);
    }
  };

  const handleSearch = async () => {
    const result = await handleApiCall({
      method: 'get',
      url: `/ads/search?value=${encodeURIComponent(searchValue)}`,
    });
    if (result?.status === 200) {
      setAds(result?.data?.ads);
      setCount(result?.data?.ads?.length);
    }
  };

  useEffect(() => {
    if (!auth?.isLogin) navigate('/login');
    else getAllAds();
  }, [page, pageCount, auth?.selectedAd, auth?.isLogin]);

  useEffect(() => {
    setDeleteModalOpen(dashboard?.isDeleteModalOpen);
  }, [dashboard?.isDeleteModalOpen, setDeleteModalOpen]);

  useEffect(() => {
    setSelectedAd(auth?.selectedAd);
  }, [auth?.selectedAd, setSelectedAd]);

  return (
    <>
      <div className='ez__Home w-full relative z-1 p-5 pb-10'>
        <div className='flex flex-row justify-between items-center'>
          <h1 className='text-2xl font-semibold text-ezBlack'>Campaigns</h1>
          {ads?.length > 0 && (
            <PrimaryBtn
              btnType='submit'
              text='Start New Campaign'
              width
              handleEvent={handleAddNewAd}
            />
          )}
        </div>
        {ads?.length > 0 ? (
          <div className=' w-full block card bg-white rounded-md shadow-sm border'>
            <BasicTable
              COLUMNS={ADS_COLUMNS}
              ROWS={ads}
              paginationText='Ads'
              view='ads'
              searchText='Search Ad'
              searchValue={searchValue} // Search bar value entered
              setSearchValue={setSearchValue} // Sets the value of the search bar
              handleSearch={handleSearch} // Handles the search functionality
              actions={false}
              setSelectedValue={setSelectedAd}
              setDeleteModalOpen={setDeleteModalOpen}
              pageNumber={page}
              setPageNumber={setPage}
              pageCount={pageCount}
              setPageCount={setPageCount}
              totalCount={count}
              isApiLoading={isApiLoading}
              setSearch={setSearch}
            />
          </div>
        ) : isApiLoading ? (
          <div className='col-span-3 block w-full h-96'>
            <Spiner color='ezGreen' />
          </div>
        ) : (
          <div className='col-span-12 w-full flex items-center justify-center flex-col py-32'>
            <span className='block mb-5'>{LargeMicrophoneSvg}</span>
            <p className='text-ezGray text-sm md:text-base mb-5'>
              There are no Ads
            </p>
            <PrimaryBtn
              handleEvent={() => dispatch(handleAddNewAd)}
              text='Start New Campaign'
              btnType='button'
              classNames='w-56'
            />
          </div>
        )}
      </div>
      {deleteModalOpen && (
        <DeleteModal
          isModal={deleteModalOpen}
          isLoading={isApiLoading}
          handleCloseModal={() => {
            setDeleteModalOpen(false);
            dispatch(toggleIsDeleteModalOpen(false));
          }}
          title={`Delete ${selectedAd?.title}?`}
          description='Are you sure you want to delete this Ad?'
          handleDelete={deleteAd}
        />
      )}
    </>
  );
};

export default AdsManagment;
